export default "__VITE_ASSET__BBd3rvUk__"